import React from 'react';
import clsx from 'clsx';
import './index.scss';

const BasicCheckBoxInput = ({ value, onChange, checked, disabled, label, id }) => {
  return (
    <label htmlFor={id}>
      <span className={clsx('BasicCheckBoxInput', { checked }, { disabled })}>
        <input
          className="basic-check-box-input"
          id={id}
          type="checkbox"
          value={value}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        {label}
      </span>
    </label>
  );
};

export default BasicCheckBoxInput;